<template>
  <button
    :type="type"
    :class="['btn', sizeClass, variantClass, buttonStateClass]"
    :disabled="loading || disabled"
    @click="handleClick"
  >
    <!-- 加载状态 -->
    <span v-if="loading" class="spinner-border spinner-border-sm me-2 mr-2" role="status" aria-hidden="true"></span>

    <!-- Slot内容 -->
    <slot>
      <span>{{ loading ? loadingText : label }}</span>
    </slot>
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '', // 默认按钮文字
    },
    type: {
      type: String,
      default: 'button', // 按钮类型
    },
    variant: {
      type: String,
      default: 'primary', // 样式类型: primary, success, danger, 等
    },
    size: {
      type: String,
      default: 'md', // 按钮大小: sm, md, lg
    },
    loading: {
      type: Boolean,
      default: false, // 加载状态
    },
    loadingText: {
      type: String,
      default: 'Loading...', // 加载时的文本
    },
    disabled: {
      type: Boolean,
      default: false, // 是否禁用
    },
  },
  computed: {
    sizeClass() {
      return {
        sm: 'btn-sm',
        md: '',
        lg: 'btn-lg',
      }[this.size] || '';
    },
    variantClass() {
      return `btn-${this.variant}`;
    },
    buttonStateClass() {
      if (this.loading || this.disabled) {
        return 'btn-disabled';
      }
      return '';
    },
  },
  methods: {
    handleClick(event) {
      if (!this.loading && !this.disabled) {
        this.$emit('click', event);
      }
    },
  },
};
</script>

<style scoped>
/* 禁用时的样式 */
.btn-disabled {
  cursor: not-allowed;
  pointer-events: none; /* 移除划过效果 */
  opacity: 0.65; /* 让按钮变暗 */
}

/* 防止hover效果生效 */
.btn-disabled:hover {
  background-color: inherit !important; /* 保持原背景色 */
  border-color: inherit !important; /* 保持原边框色 */
}
</style>
